/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useContext, useEffect, useState } from 'react';

import { getCustomerRecurringBookings } from 'school-space-client/api';
import { Column, Heading, Row, UserContext, ModalContext } from 'school-space-client/components';

import RecurringBookingCard from '../components/cards/RecurringBookingCard';
import RebookingBanner from '../components/sections/rebooking/RebookingBanner';
import { openRebookingInformationModal } from '../components/sections/rebooking/modals';

const css = {
    cards: theme => ({
        marginTop: theme.layout.baseline * 2
    })
};

const isProspective = ({ stateId }) => stateId === 'prospective';
const sortProspectiveBookingsToTop = (a, b) => !isProspective(a) * 1 - !isProspective(b) * 1;

const RecurringBookings = () => {
    const { id: userId, showRebooking } = useContext(UserContext);
    const { openModal, types } = useContext(ModalContext);

    const [bookings, setBookings] = useState([]);
    const [bookingsDataHasChanged, setBookingsDataHasChanged] = useState(false);
    const sortedBookings = bookings.sort(sortProspectiveBookingsToTop);

    const refetchBookings = () => setBookingsDataHasChanged(true);

    useEffect(() => {
        getCustomerRecurringBookings(userId, {
            states: [
                'confirmed',
                'amending',
                'pending',
                'cancelled',
                ...(showRebooking ? ['prospective'] : [])
            ]
        }).then(data => {
            setBookings(data.sort(sortProspectiveBookingsToTop));
            setBookingsDataHasChanged(false);
        });
    }, [userId, bookingsDataHasChanged, showRebooking]);

    const unreviewedBookings = bookings
        .filter(isProspective)
        .filter(({ yearId }) => yearId === 2026);

    const showRebookingBanner = showRebooking && unreviewedBookings.length > 0;

    return (
        <main>
            <Row>
                <Column s={[6]} m={[12]} l={[12]}>
                    <Heading level="1" size="x-large">
                        Repeat bookings
                    </Heading>
                </Column>
            </Row>
            {showRebookingBanner && (
                <RebookingBanner
                    onClick={() =>
                        openRebookingInformationModal({
                            types,
                            openModal,
                            isClosable: true
                        })
                    }
                    unreviewedBookings={unreviewedBookings}
                />
            )}
            <div css={css.cards}>
                {sortedBookings ? (
                    sortedBookings.map(booking => (
                        <RecurringBookingCard
                            key={booking.id}
                            booking={booking}
                            onUpdate={refetchBookings}
                        />
                    ))
                ) : (
                    <p>You have no repeat bookings</p>
                )}
            </div>
        </main>
    );
};

export default RecurringBookings;
